<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="负责部门" prop="chargePost">
        <a-tree-select
          v-model="form.chargePost"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="postOptions"
          placeholder="请选择"
          :replaceFields="{ children: 'children', title: 'postName', key: 'id', value: 'id' }"
          tree-default-expand-all
        >
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="公司名称" prop="companyName">
        <a-input v-model="form.companyName" placeholder="请输入公司名称"/>
      </a-form-model-item>
      <a-form-model-item label="公司地址" prop="map">
        <Map ref="map" :value="location" @change="changeCurrentAddress"></Map>
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="address">
        <a-input v-model="form.address" placeholder="请输入内容" type="textarea" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="轮播图" prop="viewpager">
        <a-upload
          :customRequest="fileUploadRequest"
          list-type="picture-card"
          :file-list="viewpager"
          multiple
          @preview="handlePreview"
          @change="uploadImages">
          <div v-if="viewpager.length < 9">
            <a-icon type="plus"/>
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持JPG、GIF、PNG图片文件,支持多张图片上传 </span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </a-form-model-item>
      <a-form-model-item label="LOGO" prop="logo">
        <a-upload
          :customRequest="fileUploadArrayRequest"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange">
          <img v-if="form.logo" :src="form.logo" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持JPG、GIF、PNG图片文件 </span>
      </a-form-model-item>
      <a-form-model-item label="公司视频" prop="companyVideo">
        <a-upload
          accept=".mp4"
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          :customRequest="fileUploadVideoRequest"
          :beforeUpload="beforeUploadVideo"
          @change="handleVideoChange"
        >
          <video v-if="form.companyVideo" ref="video" :src="form.companyVideo" controls="controls"></video>
          <div v-else>
            <a-icon :type="uploadVideoLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持MP4等文件 </span>
      </a-form-model-item>
      <a-form-model-item label="公司简介" prop="synopsis">
        <a-input v-model="form.synopsis" placeholder="请输入内容" type="textarea" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="标签" prop="tagIds">
        <a-select v-model="tagIds" mode="multiple" style="width: 100%" placeholder="请选择">
          <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
            {{ tag.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="绑定驻场客服" prop="companyServiceIds">
        <a-select v-model="companyServiceIds" mode="multiple" style="width: 100%" placeholder="请选择">
          <a-select-option v-for="(companyService,index) in companyServiceList" :key="index" :value="companyService.id">
            {{ companyService.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="财务人员" prop="companyFinanceIds">
        <a-select v-model="companyFinanceIds" mode="multiple" style="width: 100%" placeholder="请选择">
          <a-select-option v-for="(companyFinance,index) in companyFinanceList" :key="index" :value="companyFinance.id">
            {{ companyFinance.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompany, addCompany, updateCompany } from '@/api/user/company'
import { queryPostList } from '@/api/system/post'
import Map from './Map'
import { listTag } from '@/api/user/tag'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import { listCompanyService } from '@/api/user/companyService'
import { listCompanyFinance } from '@/api/user/companyFinance'
import Vue from 'vue'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export default {
  name: 'CreateForm',
  props: {},
  components: {
    Map
  },
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploadVideoLoading: false,
      previewVisible: false,
      previewImage: '',
      formTitle: '',
      tagIds: [],
      companyServiceIds: [],
      companyFinanceIds: [],
      postOptions: [],
      // 表单参数
      form: {
        id: null,
        chargePost: null,
        companyName: null,
        province: null,
        city: null,
        county: null,
        address: null,
        longitude: null,
        latitude: null,
        viewpager: '',
        logo: '',
        companyVideo: '',
        synopsis: null,
        tagIds: null,
        companyServiceIds: null,
        companyFinanceIds: null,
        status: 0,
        cateName: null,
        createTime: null,
        remark: null
      },
      address: null,
      location: [],
      targetAddress: {},
      // 1增加,2修改
      formType: 1,
      viewpager: [],
      tagList: [],
      companyServiceList: [],
      companyFinanceList: [],
      open: false,
      rules: {
        chargePost: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        cateName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
    this.queryPostList()
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    queryPostList() {
      queryPostList().then(response => {
        this.postOptions = response.data
      })
    },
    fileUploadVideoRequest(fileInfo) {
      this.uploadVideoLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUploadVideo: function (file) {
      return new Promise((resolve, reject) => {
        const fileType = file.type
        if (fileType.indexOf('video') < 0) {
          this.$message.warning('请上传视频')
          return reject(false)
        }
        resolve(true)
      })
    },
    handleVideoChange(info) { // 上传视频
      if (info.file.status === 'uploading') {
        this.uploadVideoLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadVideoLoading = false
        this.form.companyVideo = info.file.originFileObj.ossUrl
      }
    },
    // 上传图片
    uploadImages({ fileList }) {
      this.viewpager = fileList
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.logo = info.file.originFileObj.ossUrl
      }
    },
    fileUploadArrayRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    fileUploadRequest(fileInfo) {
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    queryCompanyFinanceList() {
      const param = {}
      listCompanyFinance(param).then(response => {
        this.companyFinanceList = response.data
      })
    },
    queryCompanyServiceList() {
      const param = {}
      listCompanyService(param).then(response => {
        this.companyServiceList = response.data
      })
    },
    queryTagList() {
      const param = { type: 2 }
      listTag(param).then(response => {
        this.tagList = response.data
      })
    },
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    changeCurrentAddress(e) {
      this.address = e.address
      this.location = e.location
      this.targetAddress = {
        ...this.targetAddress,
        'longitude': e.location[0],
        'latitude': e.location[1],
        'province': e.province,
        'city': e.city,
        'district': e.district
      }
      this.form.province = e.province
      this.form.city = e.city
      this.form.county = e.district
      this.form.longitude = this.location[0]
      this.form.latitude = this.location[1]
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.viewpager = []
      this.tagIds = []
      this.targetAddress = {}
      this.companyServiceIds = []
      this.companyFinanceIds = []
      this.tagList = []
      this.companyServiceList = []
      this.companyFinanceList = []
      this.location = []
      this.form = {
        id: null,
        companyName: null,
        address: null,
        province: null,
        city: null,
        county: null,
        longitude: null,
        latitude: null,
        viewpager: '',
        logo: '',
        companyVideo: '',
        synopsis: null,
        tagIds: null,
        companyServiceIds: null,
        companyFinanceIds: null,
        cateName: null,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.queryTagList()
      this.queryCompanyServiceList()
      this.queryCompanyFinanceList()
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompany({ 'id': id }).then(response => {
        this.form = response.data
        if (this.form.viewpager) {
          this.viewpager = this.form.viewpager.split(',').map((i, idx) => ({
            uid: '-' + idx,
            name: 'image.png',
            status: 'done',
            url: i
          }))
        }
        if (this.form.tagIds) {
          this.tagIds = this.form.tagIds.split(',')
        }
        if (this.form.companyServiceIds) {
          this.companyServiceIds = this.form.companyServiceIds.split(',')
        }
        if (this.form.companyFinanceIds) {
          this.companyFinanceIds = this.form.companyFinanceIds.split(',')
        }
        if (this.form.longitude && this.form.latitude) {
          this.location = [this.form.longitude, this.form.latitude]
        }
        this.open = true
        this.formTitle = '修改'
      })
      this.queryTagList()
      this.queryCompanyServiceList()
      this.queryCompanyFinanceList()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.tagIds = this.tagIds.join(',')
      this.form.companyServiceIds = this.companyServiceIds.join(',')
      this.form.companyFinanceIds = this.companyFinanceIds.join(',')
      const newUrls = []
      this.viewpager.forEach(i => {
        if (i.url) {
          newUrls.push(i.url)
        } else {
          newUrls.push(i.originFileObj.ossUrl)
        }
      })
      this.form.viewpager = newUrls.join(',')
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            debugger
            updateCompany(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompany(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
